<template lang="">
  <el-drawer
    :visible="getCommentDialog.visible"
    title="立即评价"
    @close="handleClose"
    @closed="handleClosed"
    append-to-body
    modal-append-to-body
    class="order-drawer-container"
    :size="isMobile.matches ? '100%' : 790"
  >
    <div class="order-drawer-body">
      <div class="form-item">
        <el-input
          v-model="evaluation"
          type="textarea"
          placeholder="请填写"
          :rows="6"
          maxlength="200"
          show-word-limit
          @change="handleEvaluationChange"
        />
      </div>

      <div class="form-item">
        <label class="label">总体评价：</label>
        <div class="star-level">
          <span
            class="star"
            v-for="idx in 5"
            :class="{ active: idx <= Math.max(evaluationScore, tmpActive) }"
            @click="evaluationScore = idx"
            @mouseenter="tmpActive = idx"
            @mouseleave="tmpActive = 0"
          ></span>
        </div>
      </div>

      <div class="form-item">
        <a href="javascript:;" class="confirm-btn" @click="handleConfirm"
          >确认</a
        >
      </div>
    </div>
  </el-drawer>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "comment-dialog",

  data() {
    return {
      evaluation: "",
      evaluationScore: 0,
      tmpActive: 0,

      isMobile: window.matchMedia("(max-width: 1023px)")
    };
  },

  computed: {
    ...mapGetters("order", ["getCommentDialog"])
  },

  methods: {
    ...mapActions("order", ["requestWriteOrderComment"]),
    ...mapMutations("order", ["setCommentDialog"]),
    handleClose() {
      this.setCommentDialog({
        visible: false
      });
    },

    handleClosed() {
      this.evaluation = "";
      this.evaluationScore = 0;
      this.tmpActive = 0;
    },

    updateParams() {
      const { evaluation, evaluationScore } = this;

      this.setCommentDialog({
        params: {
          ...this.getCommentDialog.params,
          evaluation,
          evaluationScore
        }
      });
    },

    handleEvaluationChange(val) {
      this.updateParams();
    },

    handleChoose(idx) {},

    handleEnter(idx) {},

    async handleConfirm() {
      const result = await this.requestWriteOrderComment();

      if (result) {
        this.handleClose();
        if (this.getCommentDialog.closeAfter) {
          this.getCommentDialog.closeAfter();
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.label {
}

.star-level {
  display: flex;
  align-items: center;

  .star {
    width: 19px;
    height: 15px;
    background: url("../../assets/order/star_icon1.png") no-repeat 50% 0;
    background-size: 17px 15px;

    &.active {
      background-image: url("../../assets/order/star_icon2.png");
    }
  }
}

.confirm-btn {
  width: 150px;
  height: 50px;
  background-color: #008077;
  color: #fff;
  border-radius: 5px;
  line-height: 50px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/CommentDialog/index.vue